import { render } from "./Song.vue?vue&type=template&id=7b1df76e&scoped=true"
import script from "./Song.vue?vue&type=script&lang=js"
export * from "./Song.vue?vue&type=script&lang=js"

import "./Song.vue?vue&type=style&index=0&id=7b1df76e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kedaq\\Desktop\\pruebaBodyTech\\pruebaspotify\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1df76e"]])

export default __exports__